import {
    Link
} from 'react-router-dom';
import {
    Card,
    CardHeader,
    CardTitle
} from 'shared/components/ui/card';
import {
    Badge
} from 'shared/components/ui/badge';

import {
    Integration
} from './lib/config';

interface IntegrationCardProps {
  integration: Integration
}

export function IntegrationCard({
    integration
}: IntegrationCardProps) {
    return (
        <Link to={`${integration.slug}`} className="group">
            <Card className="h-full transition-all hover:border-primary/50 hover:shadow-md">
                <CardHeader>
                    <div className="mb-3 flex items-center justify-between">
                        <div className="flex size-12 items-center justify-center rounded-lg border border-border bg-card">
                            <img
                                src={integration.image || '/placeholder.svg'}
                                alt={integration.name}
                                width={32}
                                height={32}
                                className="rounded"
                            />
                        </div>
                        <Badge className='' variant="outline">{integration.type}</Badge>
                    </div>
                    <CardTitle className="text-lg">{integration.name}</CardTitle>
                </CardHeader>
            </Card>
        </Link>
    );
}
